import { useEffect, useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { getStatus } from "../api";
import { isMobileDevice } from "../utils";

export default function Home() {
  const [status, setStatus] = useState(null);
  const isMobile = isMobileDevice();

  useEffect(() => {
    let alive = true;
    const poll = async () => {
      try {
        const s = await getStatus();
        if (alive) setStatus(s);
      } catch (_) {}
    };
    poll();
    const id = setInterval(poll, 10000);
    return () => { alive = false; clearInterval(id); };
  }, []);

  const attendUrl = status?.is_open && status?.token
    ? `${window.location.origin}/attend/${status.token}`
    : null;

  return (
    <div style={s.page}>
      <div style={s.card}>

        {/* Header */}
        <div style={s.header}>
          <div>
            <h1 style={s.heading}>Hello, World.</h1>
            <p style={s.sub}>Attendance Portal</p>
          </div>
          <div style={s.statusPill(status?.is_open)}>
            <span style={s.statusDot(status?.is_open)} />
            {status === null ? "Checking…" : status.is_open ? "Open" : "Closed"}
          </div>
        </div>

        <div style={s.divider} />

        {/* Closed state */}
        {status && !status.is_open && (
          <div style={s.closedBlock}>
            <p style={s.closedText}>No attendance session is currently active.</p>
          </div>
        )}

        {/* Open state */}
        {status?.is_open && attendUrl && (
          <div style={s.openBlock}>
            <p style={s.eventLabel}>
              Event — <strong style={s.eventName}>{status.event_name}</strong>
            </p>

            {/* QR — always shown (projected on screen for students to scan) */}
            <div style={s.qrWrap}>
              <QRCodeSVG
                value={attendUrl}
                size={220}
                bgColor="#ffffff"
                fgColor="#111111"
                level="H"
              />
            </div>
            <p style={s.scanHint}>Scan with your phone to mark attendance</p>

            {/* Button — only shown on mobile */}
            {isMobile && (
              <a href={attendUrl} style={s.attendBtn}>
                Mark My Attendance →
              </a>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

const s = {
  page: {
    minHeight: "100vh",
    background: "#f5f5f5",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "'DM Mono', monospace",
    padding: "2rem",
  },
  card: {
    background: "#ffffff",
    border: "1px solid #e0e0e0",
    borderRadius: "8px",
    padding: "2.5rem 3rem",
    maxWidth: 480,
    width: "100%",
    boxShadow: "0 2px 16px rgba(0,0,0,0.06)",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
  },
  heading: {
    fontSize: "2rem",
    fontWeight: 700,
    color: "#111",
    margin: 0,
    letterSpacing: "-0.03em",
  },
  sub: {
    color: "#999",
    fontSize: "0.75rem",
    margin: "0.3rem 0 0",
    letterSpacing: "0.1em",
    textTransform: "uppercase",
  },
  statusPill: (open) => ({
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    padding: "5px 12px",
    borderRadius: "999px",
    fontSize: "0.75rem",
    fontWeight: 600,
    letterSpacing: "0.06em",
    background: open ? "#f0fdf4" : "#f5f5f5",
    color: open ? "#16a34a" : "#999",
    border: `1px solid ${open ? "#bbf7d0" : "#e5e5e5"}`,
  }),
  statusDot: (open) => ({
    width: 6,
    height: 6,
    borderRadius: "50%",
    background: open ? "#16a34a" : "#ccc",
    flexShrink: 0,
  }),
  divider: {
    height: 1,
    background: "#f0f0f0",
    margin: "1.8rem 0",
  },
  closedBlock: {
    padding: "2rem 0",
    textAlign: "center",
  },
  closedText: {
    color: "#bbb",
    fontSize: "0.88rem",
    letterSpacing: "0.04em",
  },
  openBlock: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "1.2rem",
  },
  eventLabel: {
    color: "#999",
    fontSize: "0.78rem",
    letterSpacing: "0.06em",
    textTransform: "uppercase",
    margin: 0,
    alignSelf: "flex-start",
  },
  eventName: {
    color: "#111",
    textTransform: "none",
    letterSpacing: 0,
  },
  qrWrap: {
    padding: "1.2rem",
    background: "#ffffff",
    border: "1px solid #e8e8e8",
    borderRadius: "8px",
    boxShadow: "0 1px 6px rgba(0,0,0,0.05)",
  },
  scanHint: {
    color: "#bbb",
    fontSize: "0.75rem",
    margin: 0,
    letterSpacing: "0.06em",
    textTransform: "uppercase",
  },
  attendBtn: {
    display: "block",
    width: "100%",
    padding: "14px",
    background: "#111",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    fontSize: "0.9rem",
    fontWeight: 700,
    fontFamily: "'DM Mono', monospace",
    cursor: "pointer",
    letterSpacing: "0.04em",
    textAlign: "center",
    textDecoration: "none",
    boxSizing: "border-box",
    marginTop: "0.4rem",
  },
};